import { webCrypto } from '#web-crypto';
export class Hmac {
    hashFunction;
    key;
    constructor(hashFunction, key) {
        this.hashFunction = hashFunction;
        this.key = key;
    }
    static async create(hashFunction, key) {
        const cryptoKey = await Hmac.importKey(hashFunction, key);
        return new Hmac(hashFunction, cryptoKey);
    }
    async sign(data) {
        return webCrypto.subtle.sign({
            name: 'HMAC',
            hash: { name: this.hashFunction },
        }, this.key, data);
    }
    async verify(signedData, data) {
        return webCrypto.subtle.verify({
            name: 'HMAC',
            hash: { name: this.hashFunction },
        }, this.key, signedData, data);
    }
    static async importKey(hashFunction, rawKey) {
        return webCrypto.subtle.importKey('raw', rawKey, { name: 'HMAC', hash: hashFunction }, false, ['sign', 'verify']);
    }
}
